import { Avatar, Form, Table } from 'antd';
import Box from 'components/Box';
import CurrencyInputPrecision from 'components/CurrencyInputPrecision';
import Text from 'components/Text';
import colorTheme from 'constants/color';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';

interface TablePartialVoidProps {
  items: {
    id: string;
    voidAmount: number;
    staffName: string;
    amount: number;
    serviceName: string;
    avatar: string;
  }[];
}

const TablePartialVoid = ({ items }: TablePartialVoidProps) => {
  const columns = [
    {
      title: 'Staff',
      dataIndex: 'staffName',
      render: (value: string, record: any) => (
        <Box display='flex' alignItems='center' gap='1'>
          <Avatar src={record?.avatar} alt={value} size={40}>
            {value?.[0].toUpperCase()}
          </Avatar>
          <Text variant='H8' className='medium-text'>
            {value}
          </Text>
        </Box>
      ),
      width: '200px',
    },
    {
      title: 'Service',
      dataIndex: 'serviceName',
      render: (value: string) => (
        <Text variant='H8' className='medium-text'>
          {value}
        </Text>
      ),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      render: (value: number) => (
        <Text variant='H8' className='medium-text'>
          {formatCurrency(value)}
        </Text>
      ),
      width: '180px',
    },
    {
      title: 'Void Amount',
      render: (_: any, record: any, index: number) => (
        <Form.Item name={['items', index, 'voidAmount']} style={{ marginBottom: 0 }}>
          <CurrencyInputPrecision size='small' />
        </Form.Item>
      ),
      width: '200px',
    },
  ];
  return (
    <TableContainer>
      <Table rowKey='id' pagination={false} columns={columns} dataSource={items || []} scroll={{ y: 600 }} />
    </TableContainer>
  );
};

export default TablePartialVoid;

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 8px;
  border: 1px solid #e9edf2;
  background: #fff;

  .ant-table-thead > tr > th {
    padding: 12px 16px;
    font-family: Poppins;
    font-size: 18px;
    font-weight: 500;
    color: ${colorTheme.text_4_v2};
    background: #f6f7fc;
  }
  .ant-table-tbody > tr > td {
    padding: 8px 16px;
    font-family: Poppins;
  }

  .ant-input {
    font-size: 20px;
    font-weight: 500;
    font-family: Poppins;
    text-align: center;
  }

  .medium-text {
    font-weight: 500;
  }
`;

const TotalAlocate = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  box-shadow: 0 -4px 8px -4px rgba(0, 0, 0, 0.15);
  border-radius: 0px 0px 8px 8px;
  position: sticky;
  bottom: 0;
  z-index: 100;
`;
